import styled, { css } from 'styled-components';
import { elevationTransition } from "../Styles/Utils";

const StyledSVG = /*#__PURE__*/styled.svg.withConfig({ displayName: "styled__StyledSVG", componentId: "sc-1tv2for-0" })(["display:inline-block;vertical-align:middle;fill:", ";", " ", ""],


(props) => props.color || props.theme.colors.Foreground,
elevationTransition,

({ color, hover }) =>
color !== hover &&
css(["&:hover{transition:fill 0.3s;fill:", ";}"],


(props) => props.hover));




export default StyledSVG;